/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-query-select/webhook-form-query-select.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
/*# sourceMappingURL=webhook-form-query-select.component.css.map */
